module.exports = __webpack_public_path__ + "/bundle/asset/U1_05-751e68b63fa017a5d58c17ca0f9682a6.gif";